import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Card,
  CardMedia,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import editNew from "../../../../assets/images/png/edit-new.png";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomUpload from "../../../../components/CustomUpload";
import api from "../../../../redux/actions/api";
import {
  postClinicalNotes,
  updateClinicalNote,
} from "../../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../../redux/reducers/loaderSlice";
import { getPetsCompliantSummary } from "../../../../redux/reducers/petSlice";
import {
  setAudioBlobData,
  setAudRecordingVisbility,
  setAudSaved,
} from "../../../../redux/reducers/recorderSlice";
import { showSnackBar } from "../../../../redux/reducers/snackSlice";
import { AppColors } from "../../../../util/AppColors";
import { CardCss } from "../../../../util/object";
import { notes } from "../../../../util/server";
import FilesWithCloseButton from "./FilesWithCloseButton";

// Set the app element for accessibility purposes
Modal.setAppElement("#root");

const initValues = {
  KeyIdentification: "",
  Subjective: "",
  Objective: "",
  Assessment: "",
  Plan: "",
  Conclusion: "",
};

const initCustValue = {
  subjective: "",
  objective: "",
  assessment: "",
  plan: "",
  files: [],
  uploadModVsble: false,
  fileUploadType: null,
};

const plusBtn = { color: AppColors.appPrimary, width: 25, height: 25 };

const ClinicalNotes = ({ appointment }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const savRef = useRef(false);
  const [recordData, setRecordData] = useState(null);
  const [editingSection, setEditingSection] = useState(null);
  const [petDetails, setPetDetails] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedNote, setSelectedNote] = useState(null);
  const [preModVsble, setPreModVsble] = useState(false);
  const [sections, setSections] = useState(initValues);
  const [custModVsble, setCustModVsble] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [customValue, setCustomValue] = useState(initCustValue);
  const [isNotValid, setIsNotValid] = useState(false);
  const [files, setFiles] = useState([]);
  const clinicNotes = useSelector(
    (state) => state?.pet?.complaintSummary?.data?.clinicalNotes
  );
  const { audSaved, visible, audioBlobData } = useSelector(
    (state) => state?.recorder
  );
  const appData = useSelector((state) => state?.pet?.complaintSummary?.data);
  const petRecord = useSelector((state) => state?.pet?.petDetails);
  const petData = appointment?.appoinment?.appointmentId
    ? appData?.pet
    : petRecord;
  const statusActive =
    typeof petData?.status === "boolean"
      ? petData?.status
      : petData?.status === "Y";

  useEffect(() => {
    return () => {
      if (recordData && !audSaved) {
        if (
          sections?.KeyIdentification === "" &&
          sections?.Subjective === "" &&
          sections?.Objective === "" &&
          sections?.Assessment === "" &&
          sections?.Plan === "" &&
          sections?.Conclusion === ""
        ) {
          setSections({
            KeyIdentification: recordData?.DifferentialDiagnosis,
            Subjective: recordData?.Subjective,
            Objective: recordData?.Objective,
            Assessment: recordData?.Assessment,
            Plan: recordData?.Plan,
            Conclusion: recordData?.Conclusion,
          });
        }
        if (!savRef.current) handleFinilize();
      }
    };
  }, [location, recordData, audSaved]);

  useEffect(() => {
    getPetDetails();
    const checkPermissions = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });
        // alert('Accepted the permissions');
        // setHavePermissions(true);
        // Do something with the stream if needed
      } catch (err) {
        // setHavePermissions(false);
        console.log(`${err.name} : ${err.message}`);
      }
    };
    checkPermissions();

    setSections({
      KeyIdentification: recordData?.DifferentialDiagnosis,
      Subjective: recordData?.Subjective,
      Objective: recordData?.Objective,
      Assessment: recordData?.Assessment,
      Plan: recordData?.Plan,
      Conclusion: recordData?.Conclusion,
    });
  }, [recordData]);

  const getPetDetails = async () => {
    const res = await api({ contentType: true, auth: true }).get(
      `user/pet/${appointment?.appoinment?.petId}/details`
    );

    if (res?.data.status === 302) {
      setPetDetails(res?.data?.data);
    } else {
      setPetDetails(null);
    }
  };

  const handleEditClick = (section) => {
    setEditingSection(section);
  };

  const handleInputChange = (event, section) => {
    setSections({
      ...sections,
      [section]: event?.target?.value,
    });
  };

  const ApiCall = async () => {
    // if (!audioBlob) return;
    if (!audioBlobData) return;
    dispatch(setAudSaved(false));
    dispatch(showLoader());
    const str = Object.entries(petDetails)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");

    const formData = new FormData();
    formData.append("audio_file", audioBlobData, "recording.webm");
    // formData.append("audio_file", audioBlob, "recording.webm");
    formData.append("medical_history", str);
    try {
      const response = await axios.post(notes, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setRecordData(response.data);
      dispatch(hideLoader());
      dispatch(
        showSnackBar({
          message: "Record created successfully!",
          type: "success",
        })
      );
      dispatch(setAudRecordingVisbility(false));
      await localStorage.removeItem("appointment");
    } catch (error) {
      console.error("Error uploading audio:", error);
      dispatch(hideLoader());
    }
  };

  // function blobToFile(theBlob, fileName) {
  //   theBlob.lastModifiedDate = new Date();
  //   theBlob.name = fileName;
  //   return theBlob;
  // }

  // function playAudioBlob(blob) {
  //   if (!blob) return;
  //   const url = URL.createObjectURL(blob);
  //   return url;
  // }

  const handleFinilize = () => {
    savRef.current = true;
    setEditingSection(null);
    const data = {
      subjective:
        sections?.Subjective ??
        recordData?.Subjective ??
        customValue?.subjective ??
        null,
      objective:
        sections?.Objective ??
        recordData?.Objective ??
        customValue?.objective ??
        null,
      assessment:
        sections?.Assessment ??
        recordData?.Assessment ??
        customValue?.assessment ??
        null,
      plan: sections?.Plan ?? recordData?.Plan ?? customValue?.plan ?? null,
      conclusion: sections?.Conclusion ?? recordData?.Conclusion ?? null,
      tag:
        sections?.KeyIdentification ??
        recordData?.DifferentialDiagnosis ??
        null,
    };

    if (
      (data?.subjective === null || data?.subjective === "") &&
      (data?.objective === null || data?.objective === "") &&
      (data?.assessment === null || data?.assessment === "") &&
      (data?.plan === null || data?.plan === "")
    ) {
      setIsNotValid(true);
      return;
    }
    // const form = new FormData();
    // form.append("subjective", sections?.Subjective ?? recordData?.Subjective);
    // form.append("objective", sections?.Objective ?? recordData?.Objective);
    // form.append("assessment", sections?.Assessment ?? recordData?.Assessment);
    // form.append("plan", sections?.Plan ?? recordData?.Plan);
    // form.append("conclusion", sections?.Conclusion ?? recordData?.Conclusion);
    // form.append(
    //   "tag",
    //   sections?.KeyIdentification ?? recordData?.DifferentialDiagnosis
    // );

    // form.append("file", audioBlobData);

    // form.append("file", blobToFile(audioBlobData, "audio.webp"));
    // form.append(
    //   "file",
    //   new File([audioBlobData], "audio.webp", { lastModified: Date.now() })
    // );
    // form.append("file", playAudioBlob(audioBlobData));
    const appId = appointment?.appoinment?.appointmentId;
    if (!isEditModal) {
      dispatch(postClinicalNotes({ appId, data })).then((res) => {
        if (res?.payload) {
          dispatch(setAudSaved(true));
          dispatch(setAudRecordingVisbility(false));
          dispatch(setAudioBlobData(null));
          setRecordData(null);
          setIsNotValid(false);
          handleCloseCustMod();
          dispatch(getPetsCompliantSummary(appId));
          dispatch(
            showSnackBar({
              message: "Changes updated successfully!",
              type: "success",
            })
          );
        }
      });
    } else {
      const form = new FormData();
      if (isEditModal) {
        form.append("noteId", selectedNote?.id);
      }
      for (var key in data) {
        form.append(key, data[key]);
      }

      dispatch(updateClinicalNote({ noteId: selectedNote?.id, form })).then(
        (res) => {
          if (res?.payload) {
            dispatch(setAudSaved(true));
            dispatch(setAudRecordingVisbility(false));
            dispatch(setAudioBlobData(null));
            setRecordData(null);
            setIsNotValid(false);
            handleCloseCustMod();
            dispatch(getPetsCompliantSummary(appId));
            dispatch(
              showSnackBar({
                message: "Changes updated successfully!",
                type: "success",
              })
            );
          }
        }
      );
    }
  };

  const handleClosePrevMod = () => {
    setSelectedNote(null);
    setPreModVsble(false);
  };

  const handlePreNote = (note) => {
    setSelectedNote(note);
    setPreModVsble(true);
  };

  const handleCreateSoapNote = () => {
    dispatch(setAudRecordingVisbility(true));
    localStorage.setItem("appointment", JSON.stringify(appointment));
  };

  const handleCustomNote = () => {
    setCustModVsble(true);
  };

  const handleCloseCustMod = () => {
    setCustModVsble(false);
    setIsEditModal(false);
    setSelectedNote(null);
    setIsNotValid(false);
    setCustomValue(initCustValue);
  };

  const onChangeModvalue = (name, value) => {
    setCustomValue({ ...customValue, [name]: value });
    if (
      (customValue?.subjective === null || customValue?.subjective === "") &&
      (customValue?.objective === null || customValue?.objective === "") &&
      (customValue?.assessment === null || customValue?.assessment === "") &&
      (customValue?.plan === null || customValue?.plan === "")
    ) {
      setIsNotValid(true);
    } else {
      setIsNotValid(false);
    }
  };

  const handleFileUpload = (typ) => {
    setCustomValue({
      ...customValue,
      uploadModVsble: true,
      fileUploadType: typ,
    });
  };

  const handleCloseUploadMod = () => {
    setCustomValue({
      ...customValue,
      uploadModVsble: false,
      fileUploadType: null,
    });
    setFiles([]);
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = files?.length > 0 ? [...files] : [];

    const readFiles = Array.from(fileList).map((file, i) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
              i,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setFiles(fileLists))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleInventImageRemove = (ind) => {
    const reqList = files
      ?.filter((fle, i) => i !== ind)
      ?.map((fle, i) => ({ ...fle, i }));
    setFiles(reqList);
  };

  const handleSaveFiles = () => {
    const reqFiles = [
      ...customValue?.files,
      ...files?.map((fle) => ({
        ...fle,
        type: customValue?.fileUploadType,
      })),
    ]?.map((fle, i) => ({ ...fle, i }));

    setCustomValue({
      ...customValue,
      files: reqFiles,
      uploadModVsble: false,
      fileUploadType: null,
    });
    setFiles([]);
  };

  const handleEditModal = (cl) => {
    setCustomValue(cl);
    setSelectedNote(cl);
    setCustModVsble(true);
    setIsEditModal(true);
  };

  return (
    <>
      <div className="w100Per mt20 common-pb-50 scroll-80vh">
        {/* {audioBlobData && !recordData && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-end mt20">
              <div className="">
                <CustomButton text="Generate SOAP" onClick={ApiCall} />
              </div>
            </div>
          </Grid>
        )} */}

        {recordData && !audSaved ? (
          <>
            {[
              "Key Identification/Diagnosis",
              "Subjective",
              "Objective",
              "Assessment",
              "Plan",
              "Conclusion",
            ].map((section, i) =>
              i === 0 ? (
                <div key={section} className="mt20">
                  <div className="flex-row-ali-cen">
                    <div className="heading-fw600 fs14 black">{section}</div>
                    <Typography
                      className={`font-medium fs10 card-time blu-back white-color ml5`}
                    >
                      {sections?.KeyIdentification}
                    </Typography>
                  </div>
                </div>
              ) : (
                <div key={section} className="mt20">
                  <div className="flex-row-between-align-center">
                    <div className="heading-fw600 fs14 black">{section}</div>
                    {!audSaved && (
                      // !dataSaved
                      <div
                        className="cursor"
                        onClick={() => handleEditClick(section)}
                      >
                        <img src={editNew} alt="edit" />
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      border: "2px solid #E3E3EB",
                      borderRadius: "10px",
                    }}
                    className="text400 mt10 back-white"
                  >
                    {editingSection === section ? (
                      <TextField
                        fullWidth
                        value={sections?.[section]}
                        onChange={(event) => handleInputChange(event, section)}
                      />
                    ) : (
                      <div className="p15">{sections?.[section]}</div>
                    )}
                  </div>
                </div>
              )
            )}
            {!audSaved && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="clinic-mod-btn-pos mt20">
                  <div className="ml10 mb10">
                    <CustomButton
                      text="Save"
                      smallBtn
                      onClick={handleFinilize}
                    />
                  </div>
                </div>
              </Grid>
            )}
          </>
        ) : null}
        {/* {!visible && (
          <>
            {!recordData && !clinicNotes && clinicNotes?.length === 0 && (
              <div className="no-rec">No records available</div>
            )}
            <div
              className={`flex-center mb20 ${
                (recordData || clinicNotes) && "mt30"
              }`}
            >
              {recordData ? null : (
                <div className="">
                  <CustomButton
                    text="Create SOAP Notes"
                    onClick={handleCreateSoapNote}
                    smallBtn
                  />
                </div>
              )}
            </div>
          </>
        )} */}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row-ali-cen">
            <div>
              <Typography className="blue-color fs16 pl10 txt-semi-bold">
                Recent Recordings
              </Typography>
            </div>
            <div className="flex1-end">
              {audioBlobData && !recordData && (
                <div>
                  <CustomButton
                    text="Generate SOAP"
                    onClick={() => {
                      if (audioBlobData && !recordData) ApiCall();
                    }}
                    smallBtn
                    grayBtn={!statusActive}
                    disabled={!statusActive}
                  />
                </div>
              )}
              <div className="ml10">
                <CustomButton
                  text="Add Notes"
                  onClick={handleCustomNote}
                  smallBtn
                  grayBtn={!statusActive}
                  disabled={!statusActive}
                />
              </div>
              {recordData ? null : (
                <div className="mh10">
                  <CustomButton
                    text="Record SOAP"
                    onClick={handleCreateSoapNote}
                    smallBtn
                    grayBtn={!statusActive}
                    disabled={!statusActive}
                  />
                </div>
              )}
            </div>
          </div>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row-ali-cen">
            <div className="mt15 ml20 p10">
              <CustomCheckbox checked={true} />
            </div>
            <div className="w20Per">
              <Card sx={CardCss}>
                <Typography>Ansn</Typography>
              </Card>
            </div>
          </div>
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="ph20 pb100"
        >
          <div className="box-hor-split mv20" />
          <div className="font-bold fs14 mv20 blue-color">
            Clinical Notes History
          </div>
          <div className="flex-center">
            <div className="w75Per">
              <CustomTextField
                placeholder="Search"
                fullWidth
                backgroundColor={AppColors.lightPink}
                value={searchValue}
                handleChange={(e) => setSearchValue(e?.target?.value)}
              />
            </div>
          </div>
          <div className="pb100 w100Per">
            {appointment?.appoinment?.appointmentId &&
            clinicNotes?.filter(
              (cn) =>
                cn?.appointment?.doctorName
                  ?.toLowerCase()
                  ?.includes(searchValue.toLowerCase()) ||
                cn?.appointment?.reason
                  ?.toLowerCase()
                  ?.includes(searchValue.toLowerCase())
            )?.length > 0 ? (
              clinicNotes
                ?.filter(
                  (cn) =>
                    cn?.appointment?.doctorName
                      ?.toLowerCase()
                      ?.includes(searchValue.toLowerCase()) ||
                    cn?.appointment?.reason
                      ?.toLowerCase()
                      ?.includes(searchValue.toLowerCase())
                )
                ?.map((cln, ind) => {
                  const apntmnt = cln?.appointment;
                  return (
                    <div className="flex-row-ali-cen mv10" key={ind + "pres"}>
                      <div className="w20Per">
                        <div className="back-img">
                          <div className="flex-center h100">
                            <div className="flex-column flex-center">
                              <Typography className="black2 fs10 font-bold">
                                {moment(new Date(cln?.createdDate)).format(
                                  "DD MMM"
                                )}
                              </Typography>
                              <Typography className="black2 fs10 font-bold mt5">
                                {moment(new Date(cln?.createdDate)).format(
                                  "YYYY"
                                )}
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="w60Per">
                        <Card sx={CardCss} className="inner-cards h110">
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              className="mt10"
                            >
                              <div className="card-top-color card-top-blue-color" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <div className="ph10">
                                <div className="flex-row">
                                  <div className="w80Per">
                                    <div className="flex-start">
                                      <div className="flex-column w10Per">
                                        <div className="h50">
                                          {apntmnt?.doctorImage ? (
                                            <CardMedia
                                              image={apntmnt?.doctorImage}
                                              className="img-h40"
                                            />
                                          ) : (
                                            <div className="flex-center img-hw40 back-gray2">
                                              <Typography className="font-bold fs30 white-color capitalize">
                                                {apntmnt?.doctorName?.[0]}
                                              </Typography>
                                            </div>
                                          )}
                                        </div>
                                        <div className="card-light-blue-back card-time flex-center">
                                          <Typography className="txt-regular card-blue2 fs12">
                                            {moment(
                                              new Date(cln?.createdDate)
                                            ).format("HH:mm")}
                                          </Typography>
                                        </div>
                                      </div>
                                      <div className="flex-column ml15 jus-con-spa-bet">
                                        <div className="h50">
                                          <Typography className="font-bold fs14 black capitalize">
                                            Dr. {apntmnt?.doctorName}
                                          </Typography>
                                          {/* <Typography className="gray7 fs14 font-medium mt5 capitalize">
                                            {apntmnt?.reason}
                                          </Typography> */}
                                        </div>
                                        <div className="card-con-blue-back card-time flex-center w100Px">
                                          <Typography className="txt-regular white-color fs12">
                                            {apntmnt?.appointmentType}
                                          </Typography>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w10Per">
                                    {appointment?.appoinment?.appointmentId ===
                                    cln?.appointmentId ? (
                                      <div className="flex-center h90">
                                        <div
                                          className="cursor"
                                          onClick={() => handleEditModal(cln)}
                                        >
                                          <div className="flex-center">
                                            <EditIcon sx={plusBtn} />
                                          </div>
                                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                            Edit
                                          </Typography>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="w10Per">
                                    <div className="flex-center h90">
                                      <div
                                        className="cursor"
                                        onClick={() => handlePreNote(cln)}
                                      >
                                        <div className="flex-center">
                                          <VisibilityIcon sx={plusBtn} />
                                        </div>
                                        <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                          View
                                        </Typography>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </Card>
                      </div>
                    </div>
                  );
                })
            ) : (
              <div className="no-rec">No records available</div>
            )}
          </div>
        </Grid>
      </div>
      <CustomModal
        open={preModVsble}
        onClose={handleClosePrevMod}
        header=""
        modal
        modalWidth={70}
      >
        <div className="scroll-70vh w100Per">
          {selectedNote ? (
            <>
              <div className="mt20">
                <div className="flex-row-ali-cen">
                  <div className="heading-fw600 fs14 black">
                    Key Identification/Diagnosis
                  </div>
                  {selectedNote?.tag && (
                    <Typography className="font-medium fs10 card-time blu-back white-color ml10">
                      {selectedNote?.tag}
                    </Typography>
                  )}
                </div>
              </div>
              {/* <div className="mt20">
                <div className="flex-row-between-align-center">
                  <div className="heading-fw600 fs14 black">Subjective</div>
                </div>
                <div className="text400 mt10 p15 back-white cli-not-box">
                  {selectedNote?.subjective}
                </div>
              </div> */}
              <div className="flex-row-ali-cen mt20">
                <div className="w15Per">
                  <div className="flex-column flex-center mb20">
                    <div className="txt-regular fs40 gray19">S</div>
                    <div className="txt-semi-bold gray19 fs12">Subjective</div>
                  </div>
                </div>
                <div className="w85Per">
                  <div className="flex-center">
                    <div className="w100Per">
                      <CustomTextField
                        value={selectedNote?.subjective}
                        fullWidth
                        multiline
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="mt20">
                <div className="flex-row-between-align-center">
                  <div className="heading-fw600 fs14 black">Objective</div>
                </div>
                <div className="text400 mt10 p15 back-white cli-not-box">
                  {selectedNote?.objective}
                </div>
              </div> */}
              <div className="flex-row-ali-cen mt20">
                <div className="w15Per">
                  <div className="flex-column flex-center mb20">
                    <div className="txt-regular fs40 gray19">O</div>
                    <div className="txt-semi-bold gray19 fs12">Objective</div>
                  </div>
                </div>
                <div className="w85Per">
                  <div className="flex-center">
                    <div className="w100Per">
                      <CustomTextField
                        value={selectedNote?.objective}
                        fullWidth
                        multiline
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="mt20">
                <div className="flex-row-between-align-center">
                  <div className="heading-fw600 fs14 black">Assessment</div>
                </div>
                <div className="text400 mt10 p15 back-white cli-not-box">
                  {selectedNote?.assessment}
                </div>
              </div> */}
              <div className="flex-row-ali-cen mt20">
                <div className="w15Per">
                  <div className="flex-column flex-center mb20">
                    <div className="txt-regular fs40 gray19">A</div>
                    <div className="txt-semi-bold gray19 fs12">Assessment</div>
                  </div>
                </div>
                <div className="w85Per">
                  <div className="flex-center">
                    <div className="w100Per">
                      <CustomTextField
                        value={selectedNote?.assessment}
                        fullWidth
                        multiline
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="mt20">
                <div className="flex-row-between-align-center">
                  <div className="heading-fw600 fs14 black">Plan</div>
                </div>
                <div className="text400 mt10 p15 back-white cli-not-box">
                  {selectedNote?.plan}
                </div>
              </div> */}
              <div className="flex-row-ali-cen mt20">
                <div className="w15Per">
                  <div className="flex-column flex-center mb20">
                    <div className="txt-regular fs40 gray19">P</div>
                    <div className="txt-semi-bold gray19 fs12">Plan</div>
                  </div>
                </div>
                <div className="w85Per">
                  <div className="flex-center">
                    <div className="w100Per">
                      <CustomTextField
                        value={selectedNote?.plan}
                        fullWidth
                        multiline
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt20">
                <div className="flex-row-between-align-center">
                  <div className="heading-fw600 fs14 black">Conclusion</div>
                </div>
                <div className="text400 mt10 p15 back-white cli-not-box">
                  {selectedNote?.conclusion}
                </div>
              </div>
            </>
          ) : (
            <div className="no-rec h100">No records available</div>
          )}
        </div>
      </CustomModal>

      <CustomModal
        open={custModVsble}
        onClose={handleCloseCustMod}
        header={
          isEditModal
            ? `${moment(selectedNote.createdDate).format(
                "DD MMMM YYYY"
              )} at ${moment(selectedNote.createdDate).format("HH mm")}`
            : `${moment().format("DD MMMM YYYY")} at ${moment().format(
                "HH mm"
              )}`
        }
        modal
        modalWidth={70}
      >
        <div className="scroll-70vh w100Per">
          <div className="flex-row-ali-cen">
            <div className="w15Per">
              <div className="flex-column flex-center mb20">
                <div className="txt-regular fs40 gray19">S</div>
                <div className="txt-semi-bold gray19 fs12">Subjective</div>
              </div>
            </div>
            <div className="w85Per">
              <div className="flex-center">
                <div className="w100Per">
                  <CustomTextField
                    value={customValue?.subjective}
                    handleChange={(e) =>
                      onChangeModvalue("subjective", e.target.value)
                    }
                    fullWidth
                    multiline
                  />
                  <img
                    src={require("../../../../assets/images/png/gallery.png")}
                    className="img-wh20 gal-img-pos cursor"
                    onClick={() => handleFileUpload("subjective")}
                  />
                </div>
              </div>
            </div>
          </div>

          {customValue?.files?.filter((fle) => fle?.type === "subjective") ? (
            <div className="flex-row">
              <div className="w15Per" />
              <div className="w85Per">
                <div className="flex-row-ali-cen flex-row-wrap mt20">
                  {customValue?.files
                    ?.filter((fle) => fle?.type === "subjective")
                    ?.map((li) => (
                      <img src={li?.previewUrl} className="wh50 ph10" />
                    ))}
                </div>
              </div>
            </div>
          ) : null}
          <div className="flex-row-ali-cen mt20">
            <div className="w15Per">
              <div className="flex-column flex-center mb20">
                <div className="txt-regular fs40 gray19">O</div>
                <div className="txt-semi-bold gray19 fs12">Objective</div>
              </div>
            </div>
            <div className="w85Per">
              <div className="flex-center">
                <div className="w100Per">
                  <CustomTextField
                    value={customValue?.objective}
                    handleChange={(e) =>
                      onChangeModvalue("objective", e.target.value)
                    }
                    fullWidth
                    multiline
                  />
                  <img
                    src={require("../../../../assets/images/png/gallery.png")}
                    className="img-wh20 gal-img-pos cursor"
                    onClick={() => handleFileUpload("objective")}
                  />
                </div>
              </div>
            </div>
          </div>

          {customValue?.files?.filter((fle) => fle?.type === "objective") ? (
            <div className="flex-row">
              <div className="w15Per" />
              <div className="w85Per">
                <div className="flex-row-ali-cen flex-row-wrap mt20">
                  {customValue?.files
                    ?.filter((fle) => fle?.type === "objective")
                    ?.map((li) => (
                      <img src={li?.previewUrl} className="wh50 ph10" />
                    ))}
                </div>
              </div>
            </div>
          ) : null}
          <div className="flex-row-ali-cen mt20">
            <div className="w15Per">
              <div className="flex-column flex-center mb20">
                <div className="txt-regular fs40 gray19">A</div>
                <div className="txt-semi-bold gray19 fs12">Assessment</div>
              </div>
            </div>
            <div className="w85Per">
              <div className="flex-center">
                <div className="w100Per">
                  <CustomTextField
                    value={customValue?.assessment}
                    handleChange={(e) =>
                      onChangeModvalue("assessment", e.target.value)
                    }
                    fullWidth
                    multiline
                  />
                  <img
                    src={require("../../../../assets/images/png/gallery.png")}
                    className="img-wh20 gal-img-pos cursor"
                    onClick={() => handleFileUpload("assessment")}
                  />
                </div>
              </div>
            </div>
          </div>
          {customValue?.files?.filter((fle) => fle?.type === "assessment") ? (
            <div className="flex-row">
              <div className="w15Per" />
              <div className="w85Per">
                <div className="flex-row-ali-cen flex-row-wrap mt20">
                  {customValue?.files
                    ?.filter((fle) => fle?.type === "assessment")
                    ?.map((li) => (
                      <img src={li?.previewUrl} className="wh50 ph10" />
                    ))}
                </div>
              </div>
            </div>
          ) : null}
          <div className="flex-row-ali-cen mt20">
            <div className="w15Per">
              <div className="flex-column flex-center mb20">
                <div className="txt-regular fs40 gray19">P</div>
                <div className="txt-semi-bold gray19 fs12">Plan</div>
              </div>
            </div>
            <div className="w85Per">
              <div className="flex-center">
                <div className="w100Per">
                  <CustomTextField
                    value={customValue?.plan}
                    handleChange={(e) =>
                      onChangeModvalue("plan", e.target.value)
                    }
                    fullWidth
                    multiline
                  />
                  <img
                    src={require("../../../../assets/images/png/gallery.png")}
                    className="img-wh20 gal-img-pos cursor"
                    onClick={() => handleFileUpload("plan")}
                  />
                </div>
              </div>
            </div>
          </div>
          {customValue?.files?.filter((fle) => fle?.type === "plan") ? (
            <div className="flex-row">
              <div className="w15Per" />
              <div className="w85Per">
                <div className="flex-row-ali-cen flex-row-wrap mt20">
                  {customValue?.files
                    ?.filter((fle) => fle?.type === "plan")
                    ?.map((li) => (
                      <img src={li?.previewUrl} className="wh50 ph10" />
                    ))}
                </div>
              </div>
            </div>
          ) : null}
          {/* {isEditModal ? (
            <div className="mt20">
              <div className="flex-row-between-align-center">
                <div className="heading-fw600 fs14 black">Conclusion</div>
              </div>
              <CustomTextField
                    value={customValue?.conclusion}
                    handleChange={(e) =>
                      onChangeModvalue("plan", e.target.value)
                    }
                    fullWidth
                  />
            </div>
          ) : (
            ""
          )} */}
          {isNotValid ? (
            <div className="flex-center mt10">
              <FormHelperText error>
                Please fill atleast one field
              </FormHelperText>
            </div>
          ) : null}

          <div className="flex-center">
            <div className="mt20">
              <CustomButton
                text={isEditModal ? "Update" : "Save"}
                smallBtn
                onClick={handleFinilize}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={customValue?.uploadModVsble}
        onClose={handleCloseUploadMod}
        header="Upload"
        headerCenter
        modalWidth={50}
        modal
      >
        <Grid container spacing={2}>
          {files?.length ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt20">
              <FilesWithCloseButton
                files={files}
                onClickFile={(i, fle) => handleInventImageRemove(i)}
                center
              />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomUpload
              onUploadFile={onUploadFile}
              multipleNew
              fileAccept="image/*"
              multiFiles
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-center">
              <div>
                <CustomButton
                  text="Submit"
                  smallBtn
                  onClick={handleSaveFiles}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </CustomModal>
    </>
  );
};

export default ClinicalNotes;
